import { ProgressSpinner } from 'primereact/progressspinner';
import React from 'react';

import './loadingspinner.scss';

export const showLoader = () => {
    const node: any = document.querySelector('.divSpinner');
    if (node) {
        node.style.display = 'none';
        node.removeAttribute('style');
    }
};

export const hideLoader = () => {
    const node: any = document.querySelector('.divSpinner');
    if (node) {
        node.style.display = 'none';
    }
};

export const LoadingSpinner = () => {
    return (
        <div className="fp-container">
            <ProgressSpinner
                style={{ width: '130px', height: '130px' }}
                className="fp-loader"
                strokeWidth="3"
                animationDuration="1s"
            />
        </div>
    );
};
